var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{class:_vm.state == 0 ? 'no_data' : 'no_network'},[_c('img',{staticClass:"tips_img",attrs:{"src":_vm.data[_vm.state].photoUrl,"alt":""}}),_c('p',{staticClass:"tips_text"},[_vm._v(_vm._s(_vm.data[_vm.state].tipsText))])])])}
var staticRenderFns = []

export { render, staticRenderFns }